import { HStack } from '@chakra-ui/react';
import { Input, Button } from 'Atoms';
import { StepComponent } from 'containers/Integrations/IntegrationsUtilComponents';
import {
  EsrsAssessmentsYearsDocument_,
  GetIntegrationApiKeyDocument_,
  useUpsertIntegrationKeyMutation,
} from 'models';
import { useState } from 'react';
import { Typography } from 'Tokens';
import { useToast } from 'utils/hooks';
import { CompanyIntegration, SavingState } from './MoreScopeCompany';
import { useParams } from 'react-router-dom';
import { CheckIcon } from 'Tokens/Icons/Status';

export const IntegrationInput = ({ integration }: { integration?: CompanyIntegration }) => {
  const [upsertIntegrationKey] = useUpsertIntegrationKeyMutation();
  const toast = useToast();
  const { companyId = '' } = useParams();

  const [apiKey, setApiKey] = useState<string>(integration?.apiKey ?? '');
  const [savingState, setSavingState] = useState<number>(
    integration?.apiKey ? SavingState.saved : SavingState.save
  );

  const onConfirm = async () => {
    if (savingState === SavingState.save) {
      setSavingState(SavingState.saving);
      try {
        await upsertIntegrationKey({
          variables: {
            object: {
              id: integration?.id,
              companyId: companyId,
              integrationSystemName: 'moreScope',
              apiKey: apiKey,
              isDisaggregated: false,
            },
          },
          refetchQueries: [GetIntegrationApiKeyDocument_, EsrsAssessmentsYearsDocument_],
        });
        setSavingState(SavingState.saved);
        toast({ text: 'API key saved' });
      } catch {
        setSavingState(SavingState.save);
        toast({ text: 'Failed to save Api Key', variant: 'danger' });
      }
    }
  };
  return (
    <StepComponent title="Add your API key">
      <HStack width={'100%'}>
        <Input
          value={apiKey}
          width={'100%'}
          placeholder="Enter API key"
          type="password"
          onChange={(e) => {
            setApiKey(e.target.value);
            if (savingState != SavingState.save) {
              setSavingState(SavingState.save);
            }
            if (savingState === SavingState.save) {
              if (e.target.value === integration?.apiKey) {
                setSavingState(SavingState.saved);
              }
            }
          }}
        />
        <Button
          variant={'primary'}
          onClick={() => onConfirm()}
          isLoading={savingState === SavingState.saving}
          background={savingState === SavingState.saved ? 'bg.selected' : 'bg.action.accent'}
          selected={savingState === SavingState.saved}
        >
          {savingState === SavingState.save || savingState === SavingState.saving ? (
            'Save'
          ) : (
            <HStack>
              <CheckIcon color={'text.selected'} />
              <Typography color={'text.selected'}>Saved</Typography>
            </HStack>
          )}
        </Button>
      </HStack>
    </StepComponent>
  );
};
